import { addSegments } from '../../../helpers/flow/flow';
import flow from './main.yaml';
import commonSegments from '../../segments';

// paths
import collision from './segments/collision.yaml';
import theft from './segments/theft.yaml';
import vandalism from './segments/vandalism.yaml';
import liability from './segments/liability.yaml';
import glassDamage from './segments/glass-damage.yaml';
import weather from './segments/weather.yaml';
import animalDamage from './segments/animal-damage.yaml';
import fireOrExplosion from './segments/fire-or-explosion.yaml';

// segments
import policeWithNoReport from './segments/police-with-no-report.yaml';
import policeWithReport from './segments/police-with-report.yaml';
import vehicleRepairGlass from './segments/vehicle-repair-glass.yaml';
import vehicleDamageDescription from './segments/vehicle-damage-description.yaml';
import vehicleIdErgo from './segments/vehicle-id-ergo.yaml';
import vehicleIdErgoLiability from './segments/vehicle-id-ergo-liability.yaml';
import vehicleIdNonErgoByLiability from './segments/vehicle-id-non-ergo-by-liability.yaml';
import eventCircumstancesAndAftermathNonTheft from './segments/event-circumstances-and-aftermath-non-theft.yaml';
import eventCircumstancesAndAftermathGlass from './segments/event-circumstances-and-aftermath-glass.yaml';
import forestAuthorityReportOptional from './segments/forest-authority-report-optional.yaml';
import theftPart from './segments/theft-part.yaml';
import repairComprehensive from './segments/repair-comprehensive.yaml';
import repairLiability from './segments/repair-liability.yaml';

// branches
import areThereAnyWitnesses from './branches/are-there-any-witnesses.yaml';
import customQuestionBlockAnimal from './branches/custom-question-block-animal.yaml';

const segments = {
  ...commonSegments,
  repairComprehensive,
  repairLiability,
  vehicleIdErgo,
  vehicleIdErgoLiability,
  vehicleRepairGlass,
  policeWithReport,
  policeWithNoReport,
  vehicleDamageDescription,
  fireOrExplosion,
  collision,
  theft,
  vandalism,
  weather,
  areThereAnyWitnesses,
  liability,
  vehicleIdNonErgoByLiability,
  eventCircumstancesAndAftermathNonTheft,
  eventCircumstancesAndAftermathGlass,
  glassDamage,
  animalDamage,
  forestAuthorityReportOptional,
  customQuestionBlockAnimal,
  theftPart,
};

export default addSegments(flow, segments);
